module.exports = __webpack_public_path__ + "static/media/cy.d069616c.svg";